import { NgModule } from '@angular/core';

import { NavListComponent, NavListItemComponent } from './';

@NgModule({
  declarations: [NavListComponent, NavListItemComponent],
  exports: [NavListComponent, NavListItemComponent],
})
export class NavListModule {}
